// extracted by mini-css-extract-plugin
export default {"recommendations":"H1Xhw","recommendationsTitle":"G_iOi","recommendationsGrid":"Y8IbC","loading":"wKOHW"};